import { PropsWithChildren, ReactElement, ReactNode } from "react";
import SettingPanelCollapsed from "./SettingPanel.Collapsed";
import SettingPanelExpanded from "./SettingPanel.Expanded";

export interface SettingPanelProps {
  compact: boolean;
  title: string;
  tooltip?: ReactNode;
  icon: ReactNode;
  value: string | number;
  showValueOnExpended?: boolean;
}

export default function SettingPanel({ children, compact, ...props }: PropsWithChildren<SettingPanelProps>): ReactElement {
  return compact
    ? <SettingPanelCollapsed {...props} />
    : <SettingPanelExpanded {...props}>{children}</SettingPanelExpanded>;
}
